import React, { Fragment } from 'react'
import GatsbyImage from 'gatsby-image'
import { StaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { layouts } from '@/utils/preset'
import { tablet, mobile } from '@/utils/media'
import { mq, rem } from '@/utils/helpers'
import SectionHead from '@/components/app/SectionHead'

const Template = props => {
  const { ...others } = props
  return (
    <StaticQuery
      query={query}
      render={data => {
        const sources = [
          {
            ...data.desktopImage.childImageSharp.fluid,
            media: '(min-width: 768px)'
          },
          data.mobileImage.childImageSharp.fluid
        ]
        return (
          <Root {...others}>
            <Container>
              <Head
                sub="IT SUBSIDY"
                main={(
                  <Fragment>IT導入<strong>補助金</strong></Fragment>
                )}
                lead={(
                  <Head_Lead>補助金活用で実質負担が1/3に</Head_Lead>
                )}
                body={(
                  <Fragment>「IT導入補助金」を活用することで、実質負担を大幅に削減することが可能です。2021年度は、最大450万円まで、導入にかかった総費用の最大2/3の金額が補助されます。フロントビジョンは過去4年間、IT導入支援事業者登録をしています。ITに特化した中小企業診断士が在籍しているため、補助金を活用したサービス提供・補助金の申請手続きがスピーディーかつワンストップで可能です。</Fragment>
                )}
              />
              <Image fluid={sources} alt="ECサイト IT導入補助金" />
            </Container>
          </Root>
        )
      }}
    />
  )
}

export default ThemeConsumer(Template)

const Root = styled.div`
  background-color: ${props => props.theme.gray.a};
  padding: ${rem(56)} ${rem(layouts.defs.pad.base)};
  @media ${mq.and(tablet)} {
    padding: ${rem(60)} ${rem(layouts.defs.pad.tablet)};
  }
  @media ${mq.and(mobile)} {
    padding: ${rem(56)} ${rem(layouts.defs.pad.mobile)} ${rem(56)};
  }
`

const Head = styled(SectionHead)``

const Head_Lead = styled.div`
  @media ${mq.and(mobile)} {
    br {
      display: none;
    }
  }
`

const Container = styled.div`
  margin: 0 auto;
`

const Image = styled(GatsbyImage)`
  margin-top: ${rem(40)};
  width: 100%;
  @media ${mq.and(mobile)} {
    margin-top: ${rem(24)};
  }
  > div:first-of-type {
    padding-bottom: ${props =>
      `${100 / props.fluid[0].aspectRatio}% !important`
    };
    @media ${mq.and(mobile)} {
      padding-bottom: ${props =>
        `${100 / props.fluid[1].aspectRatio}% !important`
      };
    }
  }
`

export const query = graphql`
  query SubsidySectionQuery {
    desktopImage: file(relativePath: { eq: "subsidy.png" }) {
      childImageSharp {
        fluid(maxWidth: 1616, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    mobileImage: file(relativePath: { eq: "subsidy-mobile.png" }) {
      childImageSharp {
        fluid(maxWidth: 1568, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
  }
`
